import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { AnnouncementCreate } from './AnnouncementActions'
import { useNotice } from 'app/hooks/Events/notice'
import EventSearch from '../../EventSearch'

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
`

const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    gap: 24px;
  }
`

const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #0f172a;
`

const Title = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #111827 !important;
`

const Subtitle = styled.span`
  font-size: 14px;
  color: #475569 !important;
  font-weight: 400;
`

const Controls = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  width: 100%;

  @media (min-width: 768px) {
    justify-content: flex-end;
    width: auto;
    margin-left: auto;
  }
`

const AdminAnnouncementHeader = () => {
	const { searchApi, search: searchText } = useNotice()
	const [search, setSearch] = useState(searchText)

	useEffect(() => {
		setSearch(searchText)
	}, [searchText])

	const searchData = (value: string) => {
		setSearch(value)
		searchApi(value)
	}

	return (
		<HeaderWrapper>
			<HeaderRow>
				<TitleBlock>
					<Title>공지사항</Title>
					<Subtitle>새 공지를 등록하고 고정 · 수정 · 삭제를 한 곳에서 관리하세요.</Subtitle>
				</TitleBlock>
				<Controls>
					<EventSearch search={search} searchData={searchData} />
					<AnnouncementCreate />
				</Controls>
			</HeaderRow>
		</HeaderWrapper>
	)
}

export default AdminAnnouncementHeader
